module.exports = __webpack_public_path__ + "static/media/xmg_1_filter.5d743d80.png";